module.exports = __webpack_public_path__ + "img/full4-min.41e28a82.png";